<template>
  <check-base-layout
    :pagetitle="pagetitle"
    :checkInfoData="checkFrom"
  >
    <template>
      <check-module
        :title="`基本信息`"
        v-if="financeBadDebtListVo"
      >
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">合同编号：<span
                class="col-blue"
                @click="goCompact"
                v-cust
              >{{financeBadDebtListVo.orderContractNumber}}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">客户商合同编号：{{financeBadDebtListVo.customerContractCode}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">客户名称：<span
                v-cust
                class="col-blue"
                @click="goCustomerDetail(financeBadDebtListVo)"
              >{{financeBadDebtListVo.cusName}}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="pb20">合同金额：{{financeBadDebtListVo.contractTotal | toFixed}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">已收账款：{{financeBadDebtListVo.accountsReceived | toFixed}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="">应收账款：{{financeBadDebtListVo.accountsCollect | toFixed}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">已到期应收账款：{{financeBadDebtListVo.accountsDue | toFixed}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">未到期应收账款：{{financeBadDebtListVo.accountsOutstanding | toFixed}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module
        :title="`产品清单`"
        :is-table="true"
      >
        <info-table
          :field-arr="bFieldArr"
          :table-data="bTableData"
          :table-height="`300px`"
          v-if="checkFrom.financeBadDebtListVo && checkFrom.financeBadDebtListVo.payType !== 4"
        ></info-table>
        <div v-else>
          <div
            v-for="(item,index) in bTableData"
            :key="index"
          >
            <div>
              <el-row>
                <el-col
                  :span="12"
                  :offset="6"
                  :md="{span: 16, offset: 4}"
                >
                  <div style="padding:20px 0;font-size:16px;font-weight: 500;">
                    <el-row>
                      <el-col :span='8'>{{item.shipName}}：{{item.shipPrice}}</el-col>
                      <el-col :span='8'>本期货款：{{item.shipTotal}}</el-col>
                      <el-col :span='8'>预计付款时间：{{item.shipPayDate}}</el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
              <info-table
                :field-arr="bFieldArr"
                :table-data="item.orderStockupSourseStateVoList"
                :table-height="`auto`"
              ></info-table>
            </div>
          </div>
        </div>
        <div class="allfield_title">总计</div>
        <info-table
          :field-arr="allFieldArr"
          :table-data="allTableData"
          :to-fixed-format="['contractTotal','contractCost','facePrice']"
        ></info-table>
      </check-module>
    </template>
    <template v-slot:beforeRemark>
      <el-col :span="8">
        <div class="">申请坏账金额：{{financeBadDebtListVo.badCount | toFixed}}</div>
      </el-col>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module
          :title="`审批信息`"
          v-if="systemFlowRunAuditOrgVos"
        >
          <check-info-module
            v-if="systemFlowRunAuditOrgVos.state === 3"
            :checkData="systemFlowRunAuditOrgVos"
          ></check-info-module>
          <div v-else>
            <el-row>
              <el-col :span="8">
                <div class="pb20">审批人：{{systemFlowRunAuditOrgVos.operator}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">审批时间：{{systemFlowRunAuditOrgVos.auditDate | formatData}}</div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">所属部门：{{systemFlowRunAuditOrgVos.orgName}}</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="pb20">审批结果：<span :style="{color:checkStateEx[systemFlowRunAuditOrgVos.state].color}">{{checkStateEx[systemFlowRunAuditOrgVos.state].label}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">提成扣除：<span>{{financeBadDebtListVo.commissionDeduction | toFixed}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="pb20">公司承担：<span>{{financeBadDebtListVo.companyCommitment | toFixed}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div>备注：{{systemFlowRunAuditOrgVos.auditMark}}</div>
              </el-col>
            </el-row>
          </div>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { checkStateEx } from '@/meun/date'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'

export default {
  name: 'baddebtCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '坏账审批'
    }
  },
  data () {
    return {
      checkFrom: {
        orderContractBaseOtherPayVo: {},
        financeBadDebtListVo: {
          orderShipmentStateVoList: [],
          orderContractContentStateVoList: []
        }
      },
      checkStateEx,
      allFieldArr: [{
        name: 'contractTotal',
        label: '总报价'
      }, {
        name: 'contractCost',
        label: '实际供货总价'
      }, {
        name: 'facePrice',
        label: '总面价'
      }],
      bFieldArr: [{
        name: 'brandName',
        label: '品牌'
      }, {
        name: 'seriesName',
        label: '系列'
      }, {
        name: 'proName',
        label: '产品名称'
      }, {
        name: 'proType',
        label: '型号'
      }, {
        name: 'orderNumber',
        label: '订货号'
      }, {
        name: 'count',
        label: '数量'
      }, {
        name: 'cbUnit',
        label: '单位'
      }, {
        name: 'cbExtimeValue',
        label: '货期',
        formatter (val) {
          if (!val) return '--'
          const d = val.split('-')
          if (d.length !== 2) return val
          return val + '天'
        }
      }, {
        name: 'cbPrice',
        label: '单品报价'
      }, {
        name: 'cbRate',
        label: '毛利率'
      }, {
        name: 'cbUnitPrice',
        label: '供货单价'
      }, {
        name: 'purchaseUnitPrice',
        label: '采购单价'
      }]
    }
  },
  computed: {
    bTableData () {
      const { financeBadDebtListVo, orderContractContentStateVoList, orderShipmentStateVoList } = this.checkFrom
      if (financeBadDebtListVo && financeBadDebtListVo.payType === 4) {
        return this.formatTableData(orderShipmentStateVoList)
      }
      return this.formatTableData(orderContractContentStateVoList)
    },
    financeBadDebtListVo () {
      return this.checkFrom.financeBadDebtListVo || {}
    },
    allTableData () {
      const { contractTotal, contractCost } = this.checkFrom.orderContractBaseOtherPayVo || {}
      const { facePrice } = this.checkFrom
      return [{
        contractTotal,
        contractCost,
        facePrice
      }]
    },
    systemFlowRunAuditOrgVos () {
      return this.checkFrom.systemFlowRunAuditOrgVos
    }
  },
  mounted () {
    this.getBaddebtCheckInfo()
  },
  methods: {
    goCompact () {
      this.$router.push({
        name: 'contractCreate',
        query: {
          id: this.financeBadDebtListVo.obId,
          cusId: this.financeBadDebtListVo.cusId
        }
      })
    },
    getBaddebtCheckInfo () {
      const {
        snaId
      } = this
      checkApi.getBaddebtCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = deepClone(res.data.obj)
          this.$emit('update:data', deepClone(res.data.obj))
        }
      })
    },
    formatTableData (data) {
      if (!data) return []
      return Array.isArray(data) ? data : [data]
    },
    goCustomerDetail (obj) {
      this.$router.push({
        name: 'customer/details',
        query: { id: obj.cusId }
      })
    }
  }
}
</script>

<style
  scoped
  lang="scss"
>
  v-deep .el-icon-warning-outline {
    padding-right: 10px;
  }

  .col-blue {
    color: #276cff;
  }
</style>
